const history=[
  {
    "role": "Software Engineer",
    "organisation": "Vinculum Solutions Pvt. Ltd",
    "startDate": "Feb, 2023",
    "endDate": "Present",
    "experiences": [
      "Contributed to building and sustaining enterprise-grade software solutions using Java, JavaScript, Hibernate, and the Spring MVC framework.", 
      "My responsibilities extend to the development and upkeep of the presentation layer, where I have adeptly utilized JSP, HTML/CSS, JavaScript, jQuery, and AJAX to create dynamic and user-centric interfaces.",
      "Designed and implemented modular, resilient, and scalable software components, contributing to efficient system integration and optimized performance in distributed environments.",
      "Developed a robust employee tracking system to optimize internal team operations, facilitating seamless daily task monitoring and leave management while enhancing efficiency and transparency.",
      "Successfully managed MySQL databases, prioritizing data integrity and optimizing database performance for enhanced efficiency."
    ],
    "imageSrc": require("../images/history/company.png")
  },
];

module.exports = history; 